<template>
  <div class="hero container" :class="{loaded: isLoaded}" ref="hero">
    <div class="row row-logo">
      <div class="logo-name">
        <img src="@/assets/images/hero/logo-name.svg" alt="YUYAMA DESIGN INC.">
      </div>
      <p>BRANDING / ART DIRECTION / GRAPHIC DESIGN / VISUAL IDENTITY /</p>
      <p>PACKAGE DESIGN / PRODUCT PLANNING / STRATEGY</p>
    </div>
    <div class="logo" ref="logo" :style="{top: logoFromTop}">
      <img src="@/assets/images/hero/logoY.svg" alt="YUYAMA DESIGN Y">
      <img src="@/assets/images/hero/logoD.svg" alt="YUYAMA DESIGN D">
    </div>
    <div class="catchphrase">
      <div class="catchphrase-inner">
        <img src="@/assets/images/hero/catchphrase.svg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import { throttle } from 'lodash'
export default {
  data () {
    return {
      logoFromTop: undefined,
      isLoaded: false,
      isStick: false
    }
  },
  methods: {
    handleResize: throttle(function () {
      this.adjustLogo()
    }, 300),
    adjustLogo () {
      if (this.$store.state.mq.mdlg < window.innerWidth) {
        document.getElementsByClassName('logo')[0].style.top = document.getElementsByClassName('hero')[0].offsetHeight + 'px'
      } else {
        document.getElementsByClassName('logo')[0].style.top = 0
      }
    }
  },
  mounted () {
    this.isLoaded = true
    const style = window.getComputedStyle(this.$refs.logo)
    this.logoStyleTop = Number(style.getPropertyValue('top').replace('px', ''))
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('load', this.adjustLogo) // position before updated #1
  },
  updated () {
    this.handleResize() // positioning when its updated #2
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('load', this.adjustLogo)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Hero.vue